import axios from 'axios';
import { message } from 'antd';
import { persistor } from '../redux/store';

// For public users
export const publicAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 50000, // set timeout
  headers: {
    'Content-Type': 'application/json',
    'X-user-type': 'public-user', // add custom header
  },
  withCredentials: true, // send cookies with requests
});

//For registered users
export const PrivateAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 50000,
  headers: {
    // 'Content-Type': 'application/json',
    'X-user-type': 'registered-user',
  },
  withCredentials: true,
});

// Response interceptor
PrivateAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response &&
      (error?.response?.status === 401 || error?.response?.status === 403)
    ) {
      persistor.purge();
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

//For registered users
export const VideoUploadAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-user-type': 'registered-user',
  },
  withCredentials: true,
});

// Response interceptor
VideoUploadAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response &&
      (error?.response?.status === 401 || error?.response?.status === 403)
    ) {
      message.error(
        error?.response?.message || 'Token expired, please login again'
      );
      persistor.purge();
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);
